
<ng-container *ngIf="isLoaded">
  <div style="text-align: right; font-size: 17px; margin-right: 20px; margin-top: 5px; font-weight: 600 " (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Разпределени Такси</h5>
        <p class="text-center small">за ИБАН: <b>{{getIban()}}</b> на обща стойност: <b>{{settlement.totalSum}} лв</b></p>
      </div>
      <div class="row">
        <div class="col-12" style="text-align:center">Детайли</div>
        <hr />
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">Име</th>
                <th scope="col">Комисионна</th>
                <th scope="col">Такса</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let service of settlementDetails" [ngClass]="!isSelected(service)?'':'selected-cell'" (click)="onSelected(service)">
                <td>{{getSrName(service)}}</td>
                <td>{{getSrComission(service)}} лв</td>
                <td>{{getSrTax(service)}} лв</td>
              </tr>

            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isLoaded">
  <div style="text-align: center;">
    <div class="spinner-grow spinner-grow-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-container>
